export default __webpack_public_path__ + "static/media/rainbow-door.4a44ad90.png";